import React, { Component } from 'react'
import Box from '@mui/material/Box';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import wyzrTheme from '../../styles/customTheme';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FootprintIcon from "../../images/carbon footprint 3.png";
import { GradientButton } from '../ui-components/GradientButton';
import { CircularProgress, Stack } from '@mui/material';
import { getURLBase } from '../../utils/helperFns';
import axios from 'axios';


export class CarbonFootprintForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            maxSteps: 0,
            beginForm: false,
            showFormError: false,
            carbonFootprintQuestions: [],
            answers: [],
            isReady: false
        };
    }

    startForm = () => {
        this.setState({ beginForm: true });
        let a = [];
        axios.post(getURLBase(true) + '/cfques', { gid: this.props.gid }).then(
            (res) => {
                this.setState({
                    carbonFootprintQuestions: res.data.body.questions,
                    maxSteps: res.data.body.questions.length,
                })
                res.data.body.questions.forEach(el => {
                    a.push({
                        question: el.title,
                        answer: ''
                    })
                })
                this.setState({
                    answers: a,
                    isReady: true
                })
            }
        )
    }

    handleRadioChange = (event) => {
        let a = this.state.answers;
        a[this.state.activeStep].answer = event.target.value;
        this.setState({ answers: a });
    }

    checkForFormError = () => {
        var s = this.state;
        if (s.answers[this.state.activeStep].answer !== '') {
            s.showFormError = false;
        }
        else {
            s.showFormError = true;
        }
        this.setState({ s });
    }

    handleNext = () => {
        this.checkForFormError();
        if (this.state.answers[this.state.activeStep].answer !== '') {
            if (this.state.activeStep === this.state.maxSteps - 1) {
                this.props.handleSubmit();
                axios.post(getURLBase(true) + '/submit_carbon_footprint_form', {
                    answers: this.state.answers
                }
                ).then(res => {
                    if (res.data.body.success) {
                        // request successful
                    } else {
                        // request failed
                    }
                }).catch(err => {
                    // request failed
                })
            }
            else
                this.setState({ activeStep: this.state.activeStep + 1, showFormError: false })
        }

    };

    handleBack = () => {

        if (this.state.activeStep === 0)
            this.setState({
                beginForm: false
            })
        else
            this.setState({ activeStep: this.state.activeStep - 1 })

        this.checkForFormError();
    };

    render() {
        return (
            <Stack marginTop={8} direction="column" gap={4} width="100%" alignItems={"center"}>
        
                <Box sx={{ maxWidth: 480, width: "100%", flexGrow: 1 }}>
                    {
                        !this.state.beginForm ?
                            <Box >
                                <Paper sx={{ px: 2, py: 3 }} variant="outlined">
                                    <Typography variant="h5" gutterBottom align="center">Personalize your carbon footprint</Typography>


                                    <Stack gap={4} justifyContent="center" alignItems="center" align="center" >
                                        <img src={FootprintIcon} width="25%" alt=""/>
                                        <Typography marginBottom={4} align="center" variant="p" color="text.secondary">
                                            Answer a few short questions to understand the impact of your spending on the climate
                                        </Typography>
                                        <GradientButton
                                            textTransformtype="capitalize"
                                            fullWidth onClick={this.startForm}>
                                            Start
                                        </GradientButton>
                                    </Stack>
                                </Paper>


                            </Box> :
                            <Box>
                            {
                             this.state.isReady ?
                             <>
                                <Paper className="widgetCard cardShadow" sx={{ maxWidth: 480, width: "100%" }}
                                >
                                    <Typography gutterBottom variant="h5" align="center">{this.state.carbonFootprintQuestions[this.state.activeStep].title}</Typography>
                                    <Divider light />

                                    <Box sx={{ width: '100%', p: 2 }}>


                                        <RadioGroup
                                            aria-label="stocks"
                                            name="radio-buttons-group"
                                            value={this.state.answers[this.state.activeStep].answer}
                                            onChange={this.handleRadioChange}
                                        >
                                            {this.state.carbonFootprintQuestions[this.state.activeStep].options.map((key, i) => (
                                                <FormControlLabel value={key} control={<Radio />} label={key} />
                                            ))}
                                        </RadioGroup>
                                    </Box>

                                </Paper>

                                <MobileStepper
                                    variant="progress"
                                    steps={this.state.maxSteps + 1}
                                    position="static"
                                    activeStep={this.state.activeStep + 1}
                                    nextButton={
                                        <Button
                                            size="small"
                                            onClick={this.handleNext}
                                        >
                                            {this.state.activeStep === this.state.maxSteps - 1 ? "Submit" : "Next"}
                                            {wyzrTheme.direction === 'rtl' ? (
                                                <KeyboardArrowLeft />
                                            ) : (
                                                <KeyboardArrowRight />
                                            )}
                                        </Button>
                                    }
                                    backButton={
                                        <Button size="small" onClick={this.handleBack}>
                                            {wyzrTheme.direction === 'rtl' ? (
                                                <KeyboardArrowRight />
                                            ) : (
                                                <KeyboardArrowLeft />
                                            )}
                                            Back
                                        </Button>
                                    }
                                />

                                {this.state.showFormError ?
                                    <Typography variant="body1" fontWeight={600} align="center" color="error">
                                        Please complete this step to move forward!
                                    </Typography> : null
                                }
                                </>
                                : <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "20vh" }}><CircularProgress color="success" /></Box>}
                            </Box>
                    }

                </Box>

                <Box textAlign="center">
                    <Button variant="text" onClick={this.props.handleSubmit}>
                        Skip for Now
                    </Button>
                </Box>
            </Stack>
        )
    }
}

export default CarbonFootprintForm
